import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Form from "./Form";
import { useForm } from "react-hook-form";

const DialogEditFrom = ({ visible, data, handleClose }) => {
  const form = useForm();
  const { handleSubmit, reset } = form;

  const onSubmit = (updated) => {
    console.log(updated);
    handleClose();
  };

  useEffect(() => {
    if (data) reset(data);
  }, [reset, data]);

  return (
    <Dialog open={visible} onClose={handleClose}>
      <DialogTitle>Edit</DialogTitle>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <DialogContentText>
            Please enter all required fields.
          </DialogContentText>
          <Form form={form} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Update</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

DialogEditFrom.propTypes = {
  visible: PropTypes.bool.isRequired,
  data: PropTypes.object,
  handleClose: PropTypes.func,
};

DialogEditFrom.defaultProps = {
  visible: false,
  data: null,
  handleClose: () => {},
};

export default DialogEditFrom;
